'use strict';

module.exports = /*@ngInject*/ ["$filter", "TimeZoneFactory", function ($filter, TimeZoneFactory) {
    function MessageDataQueryFactory() {

    }

    MessageDataQueryFactory.prototype.createMessageDataQuery = function (trainInfo, rate) {

        var period = TimeZoneFactory.formatUtcToBackendPeriod(trainInfo.from, trainInfo.to);

        return {
            'trainId': trainInfo.relativeTrainId,
            'projectId': trainInfo.projectId,
            'from': period.start,
            'to': period.end,
            'rate': rate
        }
    };

    return new MessageDataQueryFactory();
}];